import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoreSignalRService {

  hubConnection: HubConnection;
    

    constructor() {
    }
    private sendQrCode = new BehaviorSubject(null);
    checkSendQrCode = this.sendQrCode.asObservable();

    GetConnection() {
        return this.hubConnection;
    }

    async Connect() {
        this.hubConnection = await new HubConnectionBuilder().withUrl(environment.apiGeneralUrl + "/SignalR").build();
        await this.hubConnection.start();
        return this.hubConnection;
    }

    async Disconnect() {
        if (this.hubConnection){
          this.sendQrCode.next(null);
          await this.hubConnection.stop();
        }
    }

    async registerUserToHub(accessKey,) {
        this.hubConnection.invoke("RegisterUserToHub", accessKey);
      }
      
    async sendAccessKey() {
      this.hubConnection.on("SendAccessKey", (res) => {
        if (res) {
          this.sendQrCode.next(res);
        }
      });
    }
}
